module.exports = __webpack_public_path__ + "img/nuvid.f7b8f51.png";